import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import router from "@/router";
import userApi from "@/api/userApi";
import User, {USER_ROLE, USER_TYPE} from "@/model/user";
import Company from "@/model/company";
import UserCompany from "@/model/userCompany";
import Contract from "@/model/contract";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  token = localStorage.getItem("token") || "";
  expired_at = "";
  role = "";
  userLogging: User = null;
  user_type: USER_TYPE;
  company_linked: Company[] = [];
  userCompanies: UserCompany[] = [];
  using_company = "";
  using_contract = "";
  @Mutation
  updateUsingCompany(id: string): void {
    this.using_company = id;
    localStorage.setItem("using_company", id);
    // update ab
  }
  @Mutation
  setToken(token: string): void {
    this.token = token;
    localStorage.setItem("token", token);
  }
  @Mutation
  setExpiredAt(time: string): void {
    this.expired_at = time;
  }
  @Mutation
  setRole(role: string): void {
    this.role = role;
  }
  @Mutation
  setUserLogging(user: User): void {
    this.userLogging = user;
  }
  @Mutation
  updateUserType(type: number): void {
    this.user_type = type;
  }
  @Mutation
  updateCompanyLinked(companies: Company[]): void {
    this.company_linked = companies;
  }
  @Mutation
  updateUserCompanies(userCompanies: UserCompany[]): void {
    this.userCompanies = userCompanies ? userCompanies.sort(function(userCompanyA, userCompanyB){
      if (!userCompanyA.company) {
        return -1;
      }else if (!userCompanyB.company) {
        return 0;
      }else if (userCompanyA.company.name.toLowerCase() < userCompanyB.company.name.toLowerCase()) {
        return -1;
      }else if (userCompanyA.company.name.toLowerCase() > userCompanyB.company.name.toLowerCase()) {
        return 1;
      }

      return 0;
    }) : null;
  }
  @Mutation
  updateUsingContract(id: string): void {
    this.using_contract = id;
  }
  @Mutation
  setContract(contract: Contract): void {
    this.userLogging.customer_contracts.push(contract);
  }

  @Action({ rawError: true })
  updateToken(token: string): void {
    this.context.commit("setToken", token);
  }
  @Action
  updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  updateRole(role: string): void {
    this.context.commit("setRole", role);
  }

  @Action
  async fetchCurrentUser(): Promise<void> {
    if (this.token) {
      const data = await userApi.me();
      this.context.commit("setUserLogging", data.data);
      this.context.commit("updateUserCompanies", data.data.user_companies);
      this.context.commit("updateCompanyLinked", data.data.companies);
    }
  }

  @Action
  setUser(user: User){
    this.context.commit("setUserLogging", user);
  }



  @Action
  async setUserType(type: number): Promise<void> {
    this.context.commit("updateUserType", type);
  }

  @Action
  setCompanyLinked(companies: Company[]): void {
    this.context.commit("updateCompanyLinked", companies);
  }

  @Action
  setUserCompanies(userCompanies: UserCompany[]): void {
    this.context.commit("updateUserCompanies", userCompanies);
  }

  @Action
  setDefaultAuth(): void {
    this.context.commit("setUserLogging", null);
  }

  @Action
  logout(redirect = true): void {
    this.context.commit("setToken", "");
    this.context.commit("setExpiredAt", "");
    this.context.commit("updateUserType", null);
    this.context.commit("updateCompanyLinked", []);
    this.context.commit("setUserLogging", null);
    this.context.commit("updateUsingCompany", "");
    this.context.commit("updateUserCompanies", "");
    // this.context.commit("setUserInfor", "");
    redirect && router.push({ name: "login" });
  }

  @Action
  setUsingCompany(id): void {
    this.context.commit("updateUsingCompany", id);
  }

  @Action
  setUsingContract(id): void {
    this.context.commit("updateUsingContract", id);
  }

  @Action
  addContract(contract: Contract): void {
    this.context.commit("setContract", contract);
  }

  get getToken(): string {
    return this.token;
  }
  get getExpiredAt(): string {
    return this.expired_at;
  }
  get getRole(): string {
    return this.role;
  }

  get getUserLogging(): User {
    return this.userLogging;
  }

  get getCompanyLinked(): Company[] {
    return this.company_linked;
  }
  get getUserCompanies(): UserCompany[] {
    return this.userCompanies;
  }
  get getCompanyUsing(): string {
    return this.using_company;
  }
  get getContractUsing(): string {
    return this.using_contract;
  }

  get getCurrentyCompany() {
    return this.company_linked.find(item => item.pivot.id === this.getCompanyUsing);
  }

  get getCurrentlyUserCompany() {
    return this.userCompanies.find(item => item.id === this.getCompanyUsing);
  }

  get getCurrentyContract() {
    return this.userLogging.customer_contracts.find(item => item.id === this.getContractUsing);
  }

  get isAdmin() {
    return this.userLogging.type === USER_TYPE.STAFF && this.getCurrentlyUserCompany.role_id === USER_ROLE.ADMIN;
  }

  get isCustomer() {
    return this.userLogging.type === USER_TYPE.CUSTOMER;
  }

  get isManager() {
    return this.userLogging.type === USER_TYPE.STAFF && this.getCurrentlyUserCompany.role_id === USER_ROLE.MANAGE;
  }

  get isWitness() {
    return this.userLogging.type === USER_TYPE.STAFF && this.getCurrentlyUserCompany.role_id === USER_ROLE.WITNESS;
  }

  get isOwner() {
    return this.userLogging.type === USER_TYPE.STAFF && this.getCurrentlyUserCompany.role_id === USER_ROLE.OWNER;
  }

  get affiliationCompanyId() {
    return this.getCurrentyCompany.pivot.affiliation_company_id;
  }
}

// export default getModule(AuthModule);
